import { ElementUtils } from "../utils/element";
import { unstable_IconRadioGroupIcon } from "../../controls/icon-radio-group";
const supportedInlineOptions = [
  {
    icon: unstable_IconRadioGroupIcon.Superscript,
    label: "Superscript",
    value: "superscript"
  },
  {
    icon: unstable_IconRadioGroupIcon.Subscript,
    label: "Subscript",
    value: "subscript"
  },
  {
    icon: unstable_IconRadioGroupIcon.Code,
    label: "Code",
    value: "code"
  }
];
function isSupportedInlineType(inline) {
  return supportedInlineOptions.findIndex((option) => option.value === inline) !== -1;
}
function isSupportedInlineEntry(entry) {
  const node = entry[0];
  return ElementUtils.isInline(node) && supportedInlineOptions.findIndex((option) => option.value === node.type) !== -1;
}
export {
  isSupportedInlineEntry,
  isSupportedInlineType,
  supportedInlineOptions
};
//# sourceMappingURL=types.js.map